import React, { useEffect, useState } from "react";
import "../../../../src/styles/sideBarMenu.css";
import $ from "jquery";
import axios from "axios";
import APIService from "../../../services/apiAxiosService";
import useHttp from "../../../hooks/useHttp";
let sideMenuOptionsBU = [
 
  {
    icon: <i className="nav-item-icon Appkit4-icon icon-person-outline userMenuAlignment fa-2x"></i>,
    name: " Third Party Request",
    label: "Third Party Request",
    submenu: ["View Third Party Requests", "New Third Party Request"],
  },
  // {
  //   icon: <i className="nav-item-icon Appkit4-icon icon-management-outline fa-2x"></i>,
  //   name: "Business Impact Analysis",
  //   label: "Business Impact Analysis",
  // },
  // {
  //   icon: <i className="nav-item-icon Appkit4-icon icon-digital-transformation-outline fa-2x"></i>,
  //   name: "Manage Risks",
  //   label: "Manage Risks",
  // },
  

  // {
  //   icon: (
  //     <img className="nav-item-icon" alt="business_Icon" src={userManagementVendorIcon} />
  //   ),
  //   name: "Analyst Work Program",
  //   label: "Analyst Work Program",
  // },
  // {
  //   icon: <img className="nav-item-icon" alt="risk_Icon" src={riskIcon} />,
  //   name: "Management Risk",
  //   label: "Management Risk",
  // },
];

let sideMenuOptionsAdmin = [
  {
    icon: <i className="nav-item-icon  Appkit4-icon icon-community-outline fa-2x"></i>,
    name: "Third Party Management",
    label: "Third Party Management",
  },
  {
    icon: <i className="nav-item-icon Appkit4-icon icon-engagement-outline sizeEngagement"></i>,
    name: "User Management",
    label: "User Management",
  },
  {
    icon: <i className="nav-item-icon Appkit4-icon icon-data-outline fa-2x"></i>,
    name: "Master Repository",
    label: "Master Repository",
  },
  // {
  //   icon: <i className="nav-item-icon icon-setting-outline fa-2x"></i>,
  //   name: "Settings",
  //   label: "Settings",
  // },
];

let sideMenuOptionsManager = [
  {
    icon: (
      <i className="nav-item-icon  Appkit4-icon icon-grid-view-outline fa-2x"></i>
    ),
    name: "Dashboard",
    label: "Dashboard",
  },
  {
    icon: <i className="nav-item-icon  Appkit4-icon icon-thumb-up-outline fa-2x"></i>,
    name: "Approval Requests",
    label: "Approval Requests",
  },
  // {
  //   icon: <i className="nav-item-icon  Appkit4-icon icon-hand-outline fa-2x"></i>,
  //   name: "Risk Management Manager",
  //   label: "Risk Management",
  // },
 
  // {
  //   icon: <i className="nav-item-icon  icon-news-outline fa-2x"></i>,
  //   name: "Vendor Requests",
  //   label: "Vendor Requests",
  // },
  // {
  //   icon: <img className="nav-item-icon" alt="" src={fileandpen} />,
  //   name: "Assessment Plan Request",
  //   label: "Assessment Plan Request",
  // },
  // {
  //   icon: <i className="fa icon-setting-outline fa-2x"></i>,
  //   name: "Work Program Requests",
  //   label: "Work Program Requests",
  // },
  // {
  //   icon: <i className="fa fa-address-book-o fa-2x"></i>,
  //   name: "Risk Requests",
  //   label: "Risk Requests",
  // },
  // {
  //   icon: <img className="nav-item-icon" alt="" src={filesetting} />,
  //   name: "Risk Requests",
  //   label: "Risk Requests",
  // },
];
let sideMenuOptionsVendor = [
  
  {
    icon: <i className="nav-item-icon  Appkit4-icon icon-news-outline fa-2x"></i>,
    name: "Self Assessment",
    label: "Self Assessment",
  },
  {
    icon: <i className="nav-item-icon  Appkit4-icon icon-help-question-outline fa-2x"></i>,
    name: "Vendor Issue Management",
    label: "Issue Management",
  },
  
];
let sideMenuOptionsAnalyst = [
  {
    icon: (
      <i className="nav-item-icon  Appkit4-icon icon-grid-view-outline fa-2x"></i>
    ),
    name: "Dashboard",
    label: "Dashboard",
  },
  {
    icon: <i className="nav-item-icon Appkit4-icon icon-calendar-outline fa-2x"></i>,
    name: "Schedule Assessments",
    label: "Schedule Assessments",
  },
  {
    icon: (
      <i
        className="nav-item-icon Appkit4-icon icon-setting-outline fa-2x"
        aria-hidden="true"
      ></i>
    ),
    name: "Work Program",
    label: "Work Program",
  },
  // {
  //   icon: <i className="nav-item-icon  Appkit4-icon icon-edit-outline fa-2x"></i>,
  //   name: "Update Risks",
  //   label: "Risk Change Request",
  // },
  {
    icon: <i className="nav-item-icon Appkit4-icon icon-help-question-outline fa-2x"></i>,
    name: "Issue Management",
    label: "Issue Management",
  },
 
];
let sideMenuOptionsAssessor = [
  {
    icon: (
      <i className="nav-item-icon  Appkit4-icon icon-grid-view-outline fa-2x"></i>
    ),
    name: "Dashboard",
    label: "Dashboard",
  },
  {
    icon: <i className="nav-item-icon  Appkit4-icon icon-news-outline fa-2x"></i>,
    name: "Initiate Self Assessments",
    label: " Self Assessment",
  },
  {
    icon: <i className="nav-item-icon Appkit4-icon icon-location-outline fa-2x"></i>,
    name: "On Site Assessment",
    label: "On Site Assessment",
  },
  // {
  //   icon: <i className="fa fa-user-o fa-2x"></i>,
  //   name: "Assessor Work Program",
  //   label: "Assessor Work Program",
  // },
  // {
  //   icon: <i className="nav-item-icon  Appkit4-icon icon-hand-outline fa-2x"></i>,
  //   name: "Risk Management",
  //   label: "Risk Management",
  // },
  {
    icon: <i className="nav-item-icon Appkit4-icon icon-help-question-outline fa-2x"></i>,
    name: "Assessor Issue Management",
    label: "Issue Management",
  },
  
];

const SideMenu = (props) => {
  let finalSideMenuOptions;
  if (sessionStorage.getItem("roleId") === "6") {
    finalSideMenuOptions = sideMenuOptionsAdmin;
  } else if (sessionStorage.getItem("roleId") === "2") {
    finalSideMenuOptions = sideMenuOptionsManager;
  } else if (sessionStorage.getItem("roleId") === "1") {
    finalSideMenuOptions = sideMenuOptionsBU;
  } else if (sessionStorage.getItem("roleId") === "3") {
    finalSideMenuOptions = sideMenuOptionsAnalyst;
  } else if (sessionStorage.getItem("roleId") === "5") {
    finalSideMenuOptions = sideMenuOptionsVendor;
  } else if (sessionStorage.getItem("roleId") === "4") {
    finalSideMenuOptions = sideMenuOptionsAssessor;
  }

  const [menuOptions, setMenuOptions] = useState(sessionStorage.getItem("idamLogin") === "true"?[]:finalSideMenuOptions);
  const [menuOpenStatus, seMenuOpenStatus] = useState(true);
  const { sendRequest: clearLoginSession } = useHttp();

  if(sessionStorage.getItem("idamLogin") === "true"){
    //let menuValues= [...finalSideMenuOptions]
    let roleID  = document.cookie.split("; ").find(row => row.startsWith('_role_id=')).split('=')[1];
    let userID  = document.cookie.split("; ").find(row => row.startsWith('userId=')).split('=')[1];
    let Org  = document.cookie.split("; ").find(row => row.startsWith('org_name=')).split('=')[1];
    let orgID  = document.cookie.split("; ").find(row => row.startsWith('_org_id=')).split('=')[1];
    let loggedIN  = document.cookie.split("; ").find(row => row.startsWith('loggedIn=')).split('=')[1];
    let jwt  = document.cookie.split("; ").find(row => row.startsWith('jwtToken=')).split('=')[1];
    sessionStorage.setItem("roleId", roleID);
    sessionStorage.setItem("userId", userID);
    sessionStorage.setItem("orgId", orgID);
    sessionStorage.setItem("loggedIn", loggedIN);
    sessionStorage.setItem("jwtToken", jwt);
      axios.defaults.headers.common["roleid"] = roleID;
      axios.defaults.headers.common["userid"] = userID;
      axios.defaults.headers.common["orgid"] = orgID;
      
  }
 
  
  

  useEffect(() => {
    if (sessionStorage.getItem("idamLogin") === "true") {
      if (sessionStorage.getItem("roleId") === "5") {
    let vendorSidemenu= sideMenuOptionsVendor
        setMenuOptions(vendorSidemenu)
      }else if (sessionStorage.getItem("roleId") === "4") {
        let accessorSidemenu= sideMenuOptionsAssessor
            setMenuOptions(accessorSidemenu)
          }else if (sessionStorage.getItem("roleId") === "3") {
            let analystSidemenu= sideMenuOptionsAnalyst
                setMenuOptions(analystSidemenu)
              }else if (sessionStorage.getItem("roleId") === "2") {
                let managerSidemenu= sideMenuOptionsManager
                    setMenuOptions(managerSidemenu)
                  }else if (sessionStorage.getItem("roleId") === "1") {
                    let businessUserSidemenu= sideMenuOptionsBU
                        setMenuOptions(businessUserSidemenu)
                      }
                  else{
        let adminSidemenu = sideMenuOptionsAdmin
        setMenuOptions(adminSidemenu)
      }
    }else{
      let options = [...finalSideMenuOptions];
    if (sessionStorage.getItem("roleId") !== "6") {
      //options.shift();
      setMenuOptions(options);
    }else{
      setMenuOptions(options);
    }
  }
    
  }, []);

  
   
  const SetActiveSideBar = (componantName) => {
    let NewOptions = [];
    for (let obj of menuOptions) {
      if (componantName === obj.name) {
        obj.active = obj.active ? (obj.active === true ? false : true) : true;
        NewOptions.push(obj);
      } else {
        NewOptions.push(obj);
        obj.active = false;
      }
    }
    setMenuOptions(NewOptions);
  };
  let changeComponentHandler = async (componantName, sideMenu = false) => {
    if (componantName === null) {
      return;
    }
    if (!sideMenu) await SetActiveSideBar(componantName);
    switch (componantName) {
      case "Dashboard":
        props.history.push("/dashboard");
        return;
      case "Business Analysis":
        props.history.push("/business");
        return;
      case "Management Risk":
        props.history.push("/risk");
        return;
      case "View Third Party Requests":
        props.history.push("/thirdpartyRequestManagement");
        return;
      case "New Third Party Request":
        props.history.push("/create-thirdpartyrequest");
        return;
      case "User Management":
        props.history.push("/users");
        return;
      case "Schedule Assessments":
        props.history.push("/analyst");
        return;
      case "Update Risks":
        props.history.push("/analystRisks");
        return;
      case "Audit History":
        props.history.push("/auditHistory");
        return;
      case "Issue Management":
        props.history.push("/analystIssues");
        return;
      case "Work Program":
        props.history.push("/workProgram");
        return;
      case "Self Assessment":
        props.history.push("/vendor");
        return;
      case "Third Party Management":
        props.history.push("/admin");
        return;
      case "Settings":
        props.history.push("/settings");
        return;
      case "Master Repository":
        props.history.push("/masterRepository");
        return;
      case "Analyst Work Program":
        props.history.push("/workProgram");
        return;
      case "Business Impact Analysis":
        props.history.push("/businessImpact");
        return;
      case "Approval Requests":
        props.history.push("/manager");
        return;
      case "Initiate Self Assessments":
        props.history.push("/initiateAssessment");
        return;
      case "On Site Assessment":
        props.history.push("/onsiteAssessment");
        return;
      case "Assessor Work Program":
        props.history.push("/assessorWorkProgram");
        return;
      case "Risk Management":
        props.history.push("/riskManagement");
        return;
      case "Manage Risks":
        props.history.push("/risk");
        return;
      case "Assessor Issue Management":
        props.history.push("/assessor/issue_management");
        return;
      case "Vendor Issue Management":
        props.history.push("/vendor/issue_management");
        return;
      case "Risk Management Manager":
        props.history.push("/manager/risk_management");
        return;
      default:
        return;
    }
  };

  const handleLogout = async () => {
    clearLoginSession(APIService.clearLoginSession({ userID: sessionStorage.getItem("userId")}), (result) => {
      
    });
    props.history.push("/");
    sessionStorage.removeItem("roleId");
    sessionStorage.removeItem("loggedIn");
    sessionStorage.removeItem("userId");
    sessionStorage.removeItem("orgId");
    sessionStorage.removeItem("jwtToken");
    sessionStorage.removeItem("idamLogin");
   };

  $(".mm a").on("click", function () {
    $(".mm").find(".active").removeClass("active");
    $(this).parent().addClass("active");
  });

  $(".submenu a").on("click", function () {
    $(".submenu").find(".active").removeClass("active");
    $(this).parent().addClass("active");
    $(this).parent().parent().parent().addClass("active");
  });

  const getMenuItems = () => {
    $("#news-icon g:nth-child(2)").remove();

    return (
      <nav className="main-menu mm">
        <ul className="active ">
          {menuOptions.map((sideMenuOption, index) => {
            return (
              <li
                key={index}
                className={index === 0 ? "has-subnav active" : "has-subnav  "}
                onClick={() => changeComponentHandler(sideMenuOption.name)}
              >
                <a href="javascript:void(0);" className="focus" tabIndex="0">
                  {sideMenuOption.icon}
                  <span
                    className={
                      sideMenuOption.submenu ? "nav-text" : "nav-text"
                    }
                  >
                    {sideMenuOption.label}
                    {sideMenuOption.submenu ? (
                      <i className="fa fa-caret-down float-right"></i>
                    ) : null}
                  </span>
                </a>
                {sideMenuOption.submenu ? (
                  <ul className="submenu active">
                    {sideMenuOption.submenu
                      ? sideMenuOption.submenu.map((SidMenuLabels, index) => {
                          return (
                            <li key={index}>
                              <a
                                href="javascript:void(0);"
                                className="focus"
                                tabIndex="0"
                              >
                                <span
                                  className="nav-text p-1"
                                  onClick={() =>
                                    changeComponentHandler(SidMenuLabels, true)
                                  }
                                >
                                  {SidMenuLabels}
                                </span>
                              </a>
                            </li>
                          );
                        })
                      : null}
                  </ul>
                ) : null}
              </li>
            );
          })}
        </ul>
        <ul className="logout">
          <li>
            <a href="javscript:void(0);" onClick={handleLogout}>
              <i className="nav-item-icon Appkit4-icon icon-log-out-outline fa-2x"></i>
              <span className="nav-text">Logout</span>
            </a>
          </li>
        </ul>
      </nav>
    );
  };

  return getMenuItems();
};

export default SideMenu;
